// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2C_Ub","HeaderLogo":"Header_HeaderLogo__3d5is","HeaderSocial":"Header_HeaderSocial__RXW2X","resize":"Header_resize__3c7pi","Active":"Header_Active__4TDzY"};